import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { FinancialAccount } from '../../models/finance/financial-account';

@Injectable({
  providedIn: 'root',
})
export class FinancialAccountProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/financial-accounts';

  /** Cached per company so the chart-of-accounts tree is fetched once even when reopened. */
  private readonly byCompanyCache = new Map<string, Observable<ApiResponse<FinancialAccount[]>>>();

  /** All financial accounts for a company (flat list, all levels) — used to build the chart-of-accounts tree. */
  public getByCompany(companyReference: string): Observable<ApiResponse<FinancialAccount[]>> {
    let cached = this.byCompanyCache.get(companyReference);
    if (!cached) {
      cached = this.httpClient.get<ApiResponse<FinancialAccount[]>>(`${this.baseUrl}/company/${companyReference}`).pipe(shareReplay(1));
      this.byCompanyCache.set(companyReference, cached);
    }
    return cached;
  }

  public getById(id: string): Observable<ApiResponse<FinancialAccount>> {
    return this.httpClient.get<ApiResponse<FinancialAccount>>(`${this.baseUrl}/${id}`);
  }
}
